// Public surface for the marketplace module (secondary market).
//
// Marketplace is a NAMESPACE parent — it has no chrome of its own. It groups
// sibling sub-modules that together own the secondary-market journey:
//   - trading/   — shared data layer (types, rules, queries against /api/marketplace)
//   - browse/    — listings discovery, property details, all sellers
//   - invest/    — BUY flow (drawer)
//   - sell/      — SELL flow (create-listing drawer)
//   - orders/    — orders & listings management
// External consumers go through @modules/marketplace.

import { marketplaceRoutes as browseRoutes } from './browse/marketplaceBrowseRoute'
import { marketplaceInvestRoutes } from './invest/marketplaceInvestRoute'
import { marketplaceSellRoutes } from './sell/marketplaceSellRoute'
import { marketplaceOrdersRoutes } from './orders/marketplaceOrdersRoute'

// Static paths (/marketplace/orders) are listed before the param ones so the
// table reads in match order; vue-router ranks static segments first anyway.
export const marketplaceRoutes = [
  ...marketplaceOrdersRoutes,
  ...browseRoutes,
  ...marketplaceInvestRoutes,
  ...marketplaceSellRoutes,
]

// Sell drawer + its eligibility — mounted by portfolio's investment detail
// "Sell tokens" card, which hides / disables the CTA from the same overview.
export { SellTokensDrawerContainer, useSellEligibility } from './sell'
